import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: localStorage.getItem('chakra-ui-color-mode') || "light",
  useSystemColorMode: false,
};

const theme = extendTheme({ config });

export default theme;
